import * as React from "react";
import { outlookEvent } from "../../Entity/OutlookEvent";
import "./event.scss";
import { IPersonaSharedProps, Persona, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { Modal, IDragOptions } from 'office-ui-fabric-react/lib/Modal';
import ContactCRMRecents from './contactCRMRecent';
import ContactRecentCorrespondence from './contactRecentCorrespondence';
//import { Helper } from "../../Utils/Helper";
import { getId } from 'office-ui-fabric-react/lib/Utilities';
//import { ContextualMenu } from 'office-ui-fabric-react/lib/ContextualMenu';
//import { DirectionalHint, IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
//import { DetailsColumn } from "office-ui-fabric-react/lib/components/DetailsList/DetailsColumn";
/* import {
  Facepile,
  IFacepileProps,
  OverflowButtonType
} from "office-ui-fabric-react/lib/Facepile"; */
//https://developer.microsoft.com/en-us/fluentui#/controls/web/persona 
export interface IProps {
  data: outlookEvent;
  phrases: any;
  attendeeattending;
  attendeetentative;
  attendeedeclaine;
  attendeenotresponse;
  Getcrmdataforrecent;
  PrepareContactCRMReportUI;
  PrepareContactCRMSSOUI;
  GetCRMContactCompany;
  GetContactRelatedMails;
}

export default class EventAttendeelist extends React.Component<IProps> {
  public state ={currentview:'attending',time:new Date(),showModal:false,showcorrespondenseModal:false,showattendeetab:false};
  public facepileattending=[];
  public facepiletentative=[];
  public facepiledecline=[];
  public facepilenotresponse=[];
  public peroncallout=[];
  /*
  public facepileattending: IFacepileProps = {
    personas: [],
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: "More users",
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) =>
        alert("overflow icon clicked")
    },
    ariaDescription: "To move through the items use left and right arrow keys."
  };
  public facepiletentative: IFacepileProps = {
    personas: [],
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: "More users",
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) =>
        alert("overflow icon clicked")
    },
    ariaDescription: "To move through the items use left and right arrow keys."
  };
  public facepiledecline: IFacepileProps = {
    personas: [],
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: "More users",
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) =>
        alert("overflow icon clicked")
    },
    ariaDescription: "To move through the items use left and right arrow keys."
  };
  public facepilenotresponse: IFacepileProps = {
    personas: [],
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: "More users",
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) =>
        alert("overflow icon clicked")
    },
    ariaDescription: "To move through the items use left and right arrow keys."
  };
*/
// public _menuButtonElement: HTMLElement | null;
public selectedcontactemail='';
  public selectedcontactid=[];
  public _menuButtonElement=[];
  public crmdata=[];
  public checkedcrm=[];
  public crmservice;
  public _titleId: string =getId('title');
  public _subtitleId: string = getId('subText');
  public _correspondencetitleId: string =getId('title');
  public _correspondencesubtitleId: string = getId('subText');
  /* public _dragOptions: IDragOptions = {
    moveMenuItemText: 'Move',
    closeMenuItemText: 'Close',
    menu: ContextualMenu
  }; */
  public _dragOptions: IDragOptions=null;
  constructor(props) {
    super(props);
    this.prepareattendeefacefil(this.facepileattending,this.props.attendeeattending,"attending");
    this.prepareattendeefacefil(this.facepiletentative,this.props.attendeetentative,"tentitive");
    this.prepareattendeefacefil(this.facepiledecline,this.props.attendeedeclaine,"decline");
    this.prepareattendeefacefil(this.facepilenotresponse,this.props.attendeenotresponse,"notresone");

  }
  
 public prepareattendeefacefil=(facepile,attendeelist,type,mouseevent=false)=>{
   
     if(attendeelist!=null && attendeelist.length>0){
      attendeelist.forEach((attendee,index) => {
          let name = attendee["emailAddress"].name == ""
            ? attendee["emailAddress"].address
            : attendee["emailAddress"].name;
          let email=attendee["emailAddress"].address;
          
          let parts = name.split(" ");
          let AssingeeInitial = parts[0]
          .trim()
          .substr(0, 1)
          .toUpperCase();
          if (parts.length > 1) {
            AssingeeInitial += parts[1]
              .trim()
              .substr(0, 1)
              .toUpperCase();
          }
         

          let Persona1: IPersonaSharedProps = {
              // imageUrl: TestImages.personaFemale,
              imageInitials: AssingeeInitial,
              text: name,
              secondaryText: email,
              tertiaryText: '',
              optionalText: '',
              size:PersonaSize.size32,
              initialsColor: Math.floor(Math.random() * 15),
              showSecondaryText:true
          };

          let peoplekey=type+index;
          let currentemail=attendee["emailAddress"].address;
          if(mouseevent==false){            
            this.peroncallout[currentemail]=false;
            this.checkedcrm[currentemail]=false;
            this.selectedcontactid[currentemail]='';
            this.crmservice=null;
          }
          // https://teams.microsoft.com/_?tenantId=GUID_of_the_tenant#/conversations/19:GUID-of-user-initiating-chat_GUID-of-user-to-chat-with@unq.gbl.spaces?ctx=chat
          // let teamurl=`https://teams.microsoft.com/l/chat/0/0?users=${attendee.emailAddress.address}`;
          let teamurl=`sip:${attendee.emailAddress.address}`;
          let mailurl=`mailto:${attendee.emailAddress.address}`;
          let searchurl=`https://google.com/search?q=${attendee.emailAddress.name}`;
          let linkedinsearchurl=`https://www.linkedin.com/search/results/all/?keywords=${encodeURIComponent(attendee.emailAddress.name)}&origin=GLOBAL_SEARCH_HEADER`;
          let addressurl=`#`;
          if(this.crmdata[currentemail]!=null && this.crmdata[currentemail].Company!=null){
            addressurl=`https://www.google.com/maps/dir//${this.GetCompanyAddress(this.crmdata[currentemail].Company,true)}`;
          }
          
          facepile.push( 
            (
            <div  
                  key={peoplekey} 
                  onClick={()=>{this.personamouseover(attendee,facepile,attendeelist,type);}}
            >
              <span style={{float:'left'}} ref={menuButton => (this._menuButtonElement[currentemail] = menuButton)}>&nbsp;</span>
              <Persona  {...Persona1}  />
              
              {this.peroncallout[currentemail] ? (
                <Callout
                  className="ms-Callout-callout"
                  onDismiss={()=>{this.personamouseout(attendee,facepile,attendeelist,type);}}
                  target={this._menuButtonElement[currentemail]}
                  // directionalHint={directionalHint}
                  coverTarget={false}
                  isBeakVisible={true}
                  gapSpace={0}
                  beakWidth={16}
                >

                  <div className="ms-Callout-inner" style={{padding:'10px'}}>
                    <div className="ms-Callout-content">
                      <div style={{marginRight:'40px'}}><Persona {...Persona1} /></div>
                    {!this.checkedcrm[currentemail]?(
                       <div style={{float:'right',marginTop:'-30px'}} className="mipaloading">&nbsp;</div>
                    ):null}
                   
                    {this.crmdata[currentemail]!=null && this.crmdata[currentemail].Company!=null?(
                      <div style={{marginTop:'8px'}}>
                        <div className="crmfielddata">
                          <img src={this.crmservice+'/crm/V3.0.0.3/Images/company_ico.png'} />
                          {/* <a href={this.crmdata[currentemail].CRMURL +"/Pages/detail.aspx?page=company&ID="+this.crmdata[currentemail].Company.ID+"&slideno=1"} target="_blank">{this.crmdata[currentemail].Company.CompanyName}</a>  */}
                          <a href="#"
                          onClick={()=>{window.NavigateToTeamTab(window.GetCRMTeamsDeepLink(this.crmdata[currentemail].Company.ID,'company',1,''))} }
                          >{this.crmdata[currentemail].Company.CompanyName}</a> 
                        </div>
                        <div className="crmfielddata">
                            <img src={this.crmservice+'/crm/V3.0.0.3/Images/locate.png'} />
                            <span>{this.crmdata[currentemail].Company.Address}</span>
                            <div style={{marginLeft:"5px"}}>{this.GetCompanyAddress(this.crmdata[currentemail].Company,false)}</div>
                        </div>
                        <div className="crmfielddata">
                            <img src={this.crmservice+'/crm/V3.0.0.3/Images/ph.png'} />
                            <span dangerouslySetInnerHTML={{ __html: this.crmdata[currentemail].Company.Phone }} />
                            
                        </div>
                      </div>
                    ):this.crmdata[currentemail]!=null && this.crmdata[currentemail] && this.crmdata[currentemail].displayName!=null?(
                      <div style={{marginTop:'8px'}}>
                        <div className="crmfielddata">
                          <img src={require('../../Images/company_ico.png')} />
                          <span>{this.crmdata[currentemail].companyName}</span> 
                          <div>{this.crmdata[currentemail].jobTitle}, {this.crmdata[currentemail].department}</div>
                        </div>
                        <div className="crmfielddata">
                          <img src={require('../../Images/locate.png')} />
                          <span>{this.crmdata[currentemail].businessAddress.street}</span>
                          <div style={{marginLeft:"5px"}}>{this.crmdata[currentemail].businessAddress.city} {this.crmdata[currentemail].businessAddress.postalCode}</div>
                        </div>
                        {this.crmdata[currentemail].businessPhones && this.crmdata[currentemail].businessPhones.length>0?(
                          <div className="crmfielddata">
                            <img src={require('../../Images/ph.png')} />
                        <span>{this.Prepareoutlookcontactphones(this.crmdata[currentemail].businessPhones)}</span>
                          </div>
                        ):null}
                        {this.crmdata[currentemail].mobilePhone?(
                          <div className="crmfielddata">
                            <img src={require('../../Images/ph.png')} />
                            <span>{this.crmdata[currentemail].mobilePhone}</span>
                          </div>
                        ):null}
                      </div>
                    ):null}
                    <ul className="contactcardactions">
                      <li>
                        <a href={mailurl} target="_blank"><i className="ms-Icon ms-Icon--Mail"  /></a>
                      </li>
                      <li>
                        <a href={teamurl}><i className="ms-Icon ms-Icon--Chat" /></a>
                      </li>
                      <li>
                        <a href={searchurl} target="_blank"><i className="ms-Icon ms-Icon--World" /></a>
                      </li>
                      <li>
                        <a href={linkedinsearchurl} target="_blank"><i className="ms-Icon ms-Icon--LinkedInLogo" /></a>
                      </li>
                      {this.crmdata[currentemail]!=null && this.selectedcontactid[currentemail]!=''?(
                        <React.Fragment>
                           <li>
                                <a href={addressurl} target="_blank"><i className="ms-Icon ms-Icon--MapDirections" /></a>
                            </li>
                            <li>
                            <img onClick={this._showModal} style={{width:'15px'}} alt='' src={require('../../Images/iGlobe.png')} />
                            </li>
                        </React.Fragment>
                      ):null}
                      <li>
                        <i className="ms-Icon ms-Icon--More link" onClick={()=>{this._showCorrespondeceModal()}}  />
                      </li>
                    </ul>
                   
                    {this.crmdata[currentemail]!=null?(
                      <div>
                        {this.PrepareCRMRecentUI(this.crmdata[currentemail].Notes,this.crmservice+'/crm/V3.0.0.3/Images/note_ico.png','note')}
                      {this.PrepareCRMRecentUI(this.crmdata[currentemail].Meetings,this.crmservice+'/crm/V3.0.0.3/Images/mettingreport_ico.png','meeting')}

                      </div>
                    ):null}
                    
                    </div>
                                      
                  </div>
                </Callout>
        ) : null} 
            </div>
            
            )
            );
        });
     }
 }
 public Prepareoutlookcontactphones=(phones)=>{
   let no='',seperator='';
   phones.map((value, index) => {
    no +=seperator+value;
    seperator=', ';
  });
   return no;
 }
 public GetCompanyAddress=(company,incluedeaddress)=>{
   let address="";
   if(incluedeaddress){
    address=company.Address;
   }
   if(company.State!=''){
    address +=', '+company.State;
  }
   if(company.City!=''){
    address +=', '+company.City;
  }
   if(company.ZipCode!=''){
    address +=' '+company.ZipCode;
   }
   if(company.Country!=null && company.Country.Title!=''){
    address +=', '+company.Country.Title;
   }
   return address;
 }
 // <a href=”https://teams.microsoft.com/l/chat/0/0?users=user@domain.com”>Chat with User</a>.
 // <a href=”https://teams.microsoft.com/l/chat/0/0?users=user1@domain.com,user2@domain.com”>Chat with Group</a>.
  public personamouseover=(obj,list,attendeelist,type)=>{
    this.selectedcontactemail=obj["emailAddress"].address;
    // let currentemail=
    this.peroncallout[this.selectedcontactemail]=true;
    this.mouseeventdatapreperation(attendeelist,type);
    
    this.setState({time:new Date()});

    if(this.checkedcrm[this.selectedcontactemail]==false){
      this.checkedcrm[this.selectedcontactemail]=true;
      let fnsuccess=(response,serviceurl)=>{
        this.crmdata[this.selectedcontactemail]='dumy';
        if(response!=null){
          if(serviceurl!=null){
            let result=response.data;
            if(result.IsSucess && result.ReturnJsonString!=''){
              this.selectedcontactid[this.selectedcontactemail]=result.ObjectId;
              //this.crmservice=serviceurl.replace('/IGlobeService.svc/','');
              this.crmservice=serviceurl.replace('/api/IGService/','');
              this.crmdata[this.selectedcontactemail]=JSON.parse(result.ReturnJsonString!);
              // this.mouseeventdatapreperation(attendeelist,type);
            }
          } else{
              if(response.data.value.length>0){
                this.crmdata[this.selectedcontactemail]=response.data.value[0];
                // this.mouseeventdatapreperation(attendeelist,type);
              }
          }
        }
        this.mouseeventdatapreperation(attendeelist,type);
        this.setState({time:new Date()});
      };
      this.props.GetCRMContactCompany(obj["emailAddress"].address,fnsuccess);
    }
  }
  public personamouseout=(obj,list,attendeelist,type)=>{
        this.peroncallout[obj["emailAddress"].address]=false;
        this.mouseeventdatapreperation(attendeelist,type);
        this.setState({time:new Date()});
  }
  
  public mouseeventdatapreperation=(attendeelist,type)=>{
    switch(type){
      case "attending":
        this.facepileattending=[];
        this.prepareattendeefacefil(this.facepileattending,attendeelist,type,true);
        break;
      case "tentitive":
        this.facepiletentative=[];
        this.prepareattendeefacefil(this.facepiletentative,attendeelist,type,true);
        break;
      case "decline":
        this.facepiledecline=[];
        this.prepareattendeefacefil(this.facepiledecline,attendeelist,type,true);
        break;
      case "notresone":
        this.facepilenotresponse=[];
        this.prepareattendeefacefil(this.facepilenotresponse,attendeelist,type,true);
        break;
      default:
        break;
    }
  }
  public render() {
    return (
      <div className="Event">
        {this.state.showattendeetab?(
          <React.Fragment>
              <i onClick={()=>{this.setState({showattendeetab:false});}} className="ms-Icon ms-Icon--ChevronUpMed showhideattendee" />
              <div className="outlookeventassignecontainer">
                    <span  onClick={()=>{this.changeviw("attending");}} className={this.state.currentview=='attending'?"attendeetype typeselected":"attendeetype"}>{this.props.phrases.outlookeventattending}</span>
                    <span  onClick={()=>{this.changeviw("tentative");}} className={this.state.currentview=='tentative'?"attendeetype typeselected":"attendeetype"}>{this.props.phrases.outlookeventTentative}</span>
                    <span onClick={()=>{this.changeviw("declined");}} className={this.state.currentview=='declined'?"attendeetype typeselected":"attendeetype"}>{this.props.phrases.outlookeventDeclined}</span>
                    <span  onClick={()=>{this.changeviw("notresponsed");}} className={this.state.currentview=='notresponsed'?"attendeetype typeselected":"attendeetype"}>{this.props.phrases.outlookeventnoresponse}</span>
                    <div className={this.state.currentview=='attending'?"attendeelist attendeelistactive":"attendeelist"}>
                        {this.props.attendeeattending.length>0?(
                            <Stack tokens={{ childrenGap: 10 }}>
                                {this.facepileattending}
                            </Stack>
                            
                        ):(<span>{this.props.phrases.outlookeventnoattendee}</span>)}
                        
                    </div>
                    <div className={this.state.currentview=='tentative'?"attendeelist attendeelistactive":"attendeelist"}>
                    {this.props.attendeetentative.length>0?(
                        <Stack tokens={{ childrenGap: 10 }}>
                            {this.facepiletentative}
                        </Stack>
                        ):(<span>{this.props.phrases.outlookeventnoattendee}</span>)}
                    </div>
                    <div className={this.state.currentview=='declined'?"attendeelist attendeelistactive":"attendeelist"}>
                    {this.props.attendeedeclaine.length>0?(
                        <Stack tokens={{ childrenGap: 10 }}>
                            {this.facepiledecline}
                        </Stack>
                       
                        ):(<span>{this.props.phrases.outlookeventnoattendee}</span>)}
                    </div>
                    <div className={this.state.currentview=='notresponsed'?"attendeelist attendeelistactive":"attendeelist"}>
                    {this.props.attendeenotresponse.length>0?(
                        <Stack tokens={{ childrenGap: 10 }}>
                            {this.facepilenotresponse}
                        </Stack>
                        
                        ):(<span>{this.props.phrases.outlookeventnoattendee}</span>)}
                    </div>
          </div>
          <Modal
            titleAriaId={this._titleId}
            subtitleAriaId={this._subtitleId}
            isOpen={this.state.showModal}
            onDismiss={this._closeModal}
            isBlocking={false}
            containerClassName="modalcontainer"
            dragOptions={this._dragOptions}>
            <div className="modalheader">
              <span id={this._titleId}>{this.props.phrases.recentactivity}</span>
              <span className="modalclose" onClick={this._closeModal}>X</span>
            </div>
            <div id={this._subtitleId} className="modalbody">
              <ContactCRMRecents 
                GetCRMdataforrecent={this.GetCRMdataforrecent}
                PrepareContactCRMReportUI={this.props.PrepareContactCRMReportUI}
                PrepareContactCRMSSOUI={this.props.PrepareContactCRMSSOUI}
                phrases={this.props.phrases} />
            </div>
          </Modal>
          <Modal
            titleAriaId={this._correspondencetitleId}
            subtitleAriaId={this._correspondencesubtitleId}
            isOpen={this.state.showcorrespondenseModal}
            onDismiss={this._closecorrespondenceModal}
            isBlocking={false}
            containerClassName="modalcontainer"
            dragOptions={this._dragOptions}>
            <div className="modalheader">
              <span id={this._correspondencetitleId}>{this.props.phrases.recentactivity}</span>
              <span className="modalclose" onClick={this._closecorrespondenceModal}>X</span>
            </div>
            <div id={this._correspondencesubtitleId} className="modalbody">
              <ContactRecentCorrespondence 
                phrases={this.props.phrases}
                GetContactRelatedMails={this.props.GetContactRelatedMails}
                CurrentEmail={this.selectedcontactemail}
              />
            </div>
          </Modal>
      
          </React.Fragment>
        ):(
          <i onClick={()=>{this.setState({showattendeetab:true});}} className="ms-Icon ms-Icon--ChevronDownMed showhideattendee" />
        )}
      </div>
    );
  }
  public PrepareCRMRecentUI=(list,image,type)=>{
    let comlist=[];  
    if(list!=null && list.length>0){
      list.forEach((element,index) => {
        comlist.push(
          (
            <div className="crmrecentitem" key={type+index}>
              <img src={image} />
              <span dangerouslySetInnerHTML={{__html: element}} />
            </div>
          )
        );
      });
    }
    return comlist;
  }
  public changeviw=(newview)=>{
      if(this.state.currentview!=newview){
          this.setState({currentview:newview});
      }
  }
  private _showModal = (): void => {
    this.setState({ showModal: true });
  }

  private _closeModal = (): void => {
    this.setState({ showModal: false });
  }
  private GetCRMdataforrecent=(fnsucess)=>{
    let companyid=this.crmdata[this.selectedcontactemail].Company?this.crmdata[this.selectedcontactemail].Company.ID:0;
    this.props.Getcrmdataforrecent(this.selectedcontactemail,this.selectedcontactid[this.selectedcontactemail],companyid, fnsucess);
  }
 
  private _showCorrespondeceModal = (): void => {
    this.setState({ showcorrespondenseModal: true });
  }

  private _closecorrespondenceModal = (): void => {
    this.setState({ showcorrespondenseModal: false });
  }
}
